import React from 'react';

function DroneHeader({ drone }) {
    if (!drone.serialnumber) {
        return (
            <div className="mb-4 text-center bg-[#2a2a2a] rounded-lg border border-gray-700 p-4">
                <h4 className="text-xl font-bold text-white">DRONE {drone.title}</h4>
            </div>
        );
    } else {
        return (
            <a
                href={`http://${drone.serialnumber}.local`}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center py-4 mb-4 border-b border-primary"
            >
                <span className="font-bold text-3xl text-white
                    transition-all duration-200
                    hover:text-primary
                    hover:drop-shadow-[0_0_8px_rgba(255,204,51,0.8)]">
                    {drone.serialnumber}
                </span>
            </a>
        );
    }
}

export default DroneHeader;
